const BOARD_SIZE = 2.88;
const TRACK_FACTOR_SINGLE = 0.7;
const STUD_FACTOR_SINGLE = 2.0;
const TAPE_FACTOR = 1.6;
const COMPOUND_FACTOR = 0.8;
const ONE_LAYER_SCREW_25_FACTOR = 13.0;
const TWO_LAYER_SCREW_35_FACTOR = 13.0;
const TWO_LAYER_SCREW_25_FACTOR = 6.0;
const DRYWALL_SCREW_SELECTION_MULTIPLIER = 2;
const WAFER_FACTOR_SINGLE = 2.0;
const ANCHOR_FACTOR_SINGLE = 2.0;

export const formatValue = (value, digits = 0) => Number(value || 0).toFixed(digits);

export const calculateEstimatorResult = (form) => {
  const height = Number(form.height) || 0;
  const width = Number(form.width) || 0;
  const area = height * width;
  const isDoubleFrame = form.frameType === "double";
  const isTwoBoardsEachSide = form.boardSides === "two";
  const frameMultiplier = isDoubleFrame ? 2 : 1;

  const baseBoardsPerOneSide = area / BOARD_SIZE;
  const boardSidesMultiplier = isTwoBoardsEachSide ? 4 : 2;
  const boards = Math.ceil(baseBoardsPerOneSide * boardSidesMultiplier);

  const roundedArea = Math.ceil(area);
  const track = Math.ceil(area * TRACK_FACTOR_SINGLE * frameMultiplier);
  const stud = Math.ceil(area * STUD_FACTOR_SINGLE * frameMultiplier);
  const tape = Math.ceil(area * TAPE_FACTOR);
  const filler = Math.ceil(area * COMPOUND_FACTOR);
  const waferHead = Math.ceil(area * WAFER_FACTOR_SINGLE * frameMultiplier);
  const anchors = Math.ceil(area * ANCHOR_FACTOR_SINGLE * frameMultiplier);

  const screws25Base = isTwoBoardsEachSide
    ? area * TWO_LAYER_SCREW_25_FACTOR
    : area * ONE_LAYER_SCREW_25_FACTOR;
  const screws35Base = isTwoBoardsEachSide ? area * TWO_LAYER_SCREW_35_FACTOR : 0;
  const screws25 = Math.ceil(screws25Base * DRYWALL_SCREW_SELECTION_MULTIPLIER);
  const screws35 = Math.ceil(screws35Base * DRYWALL_SCREW_SELECTION_MULTIPLIER);
  const screwsTotal = screws25 + screws35;

  return {
    area: roundedArea,
    unit: "m²",
    Board: boards,
    CW: stud,
    UD: track,
    Tape: tape,
    Filler: filler,
    WaferHead: waferHead,
    Anchors: anchors,
    Screws25: screws25,
    Screws35: screws35,
    Screws: screwsTotal,
    calculated: true,
  };
};

